import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill'

/** Font family injected by the polyfill; `.flag-emoji` in FlagEmoji.css must use the same name. */
export const FLAG_EMOJI_FONT_FAMILY = 'Twemoji Country Flags'

/** Self-hosted copy of country-flag-emoji-polyfill/dist/TwemojiCountryFlags.woff2 (see public/fonts). */
const FLAG_EMOJI_FONT_URL = '/fonts/TwemojiCountryFlags.woff2'

// 'A' (U+0041) maps to REGIONAL INDICATOR SYMBOL LETTER A (U+1F1E6).
const REGIONAL_INDICATOR_OFFSET = 0x1f1e6 - 'A'.charCodeAt(0)

/**
 * Converts an ISO 3166-1 alpha-2 code ('DK') into its flag emoji ('🇩🇰').
 * Returns an empty string for anything that is not a two-letter code.
 */
export const getFlagEmoji = (countryCode: string | null | undefined): string => {
  const code = countryCode?.trim().toUpperCase() ?? ''
  if (!/^[A-Z]{2}$/.test(code)) return ''

  return String.fromCodePoint(
    ...Array.from(code, (letter) => letter.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET)
  )
}

/**
 * Platforms without colour flag emoji (notably Windows) render flags as two letters.
 * The polyfill detects that and injects an @font-face for the Twemoji flag font.
 * Call once at bootstrap, before React mounts.
 */
export const setupFlagEmojiPolyfill = () =>
  polyfillCountryFlagEmojis(FLAG_EMOJI_FONT_FAMILY, FLAG_EMOJI_FONT_URL)
